import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Route, Routes, redirect } from "react-router-dom";
import moment from 'moment-timezone';
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { getDatabase, ref, get } from "firebase/database";
import { 
  Home,
  Products,
  ProductsReload,
  CustomCategoriesView,
  Login,
  Budgets,
  BudgetsOld,
  CollectionsView,
  ShopifySettingsView,
  HelpView,
  RestoreProducts,
  Users,
  AddUser
} from "./routes";
import { Box } from '@mui/material';
import { AuthProvider } from "./components/Auth";

import './app.css'

const auth = getAuth();
const db = getDatabase();


const App = () => {
  const [isUser, setIsUser] = useState(false);
  moment.tz.setDefault('Etc/UTC')

  useEffect(() => {
    onAuthStateChanged(auth, (user) => {
      // console.log('auth', auth)
      // console.log('user', user)
      if (user) {
        const user_ref = ref(db, 'users/' + user.uid);
        get(user_ref).then((snapshot) => {
          let user_account = snapshot.val()?.userAccount
          if (user_account) {
            const account_ref = ref(db, 'accounts/' + user_account);
            get(account_ref).then((snapshot) => {
              const data = snapshot.val();
              if (data.features && data.features.webPortal) {
                setIsUser(true);
              }
            })
          }
        })
      }
    })
  }, [auth])

  if (!isUser) {
    return <Login/>
  }

  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route exact path="/budgets" element={<Budgets/>} />
          <Route exact path="/categories" element={<CustomCategoriesView/>} />
          <Route exact path="/products" element={<Products/>} />
          <Route exact path="/products_reload" element={<ProductsReload/>} />
          <Route exact path="/collections" element={<CollectionsView/>} />
          <Route exact path="/settings" element={<ShopifySettingsView/>} />
          <Route exact path="/help" element={<HelpView/>} />
          <Route exact path="/restore_products" element={<RestoreProducts/>} />
          <Route exact path="/users" element={<Users/>} />
          <Route exact path="/users/add" element={<AddUser/>} />
          <Route path="/*" element={<Products/>} />
          {/* <Route path="/*" element={<Home/>} /> */}
        </Routes>
      </Router>
    </AuthProvider>
  );
};

export default App;
